import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { MDBSpinner } from "mdb-react-ui-kit";
import { getBatchSkus } from "../services/batchesApi";
import "./BatchPrintPage.css";

export default function BatchPrintPage() {
  const { batchId } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [data, setData] = useState(null);

  const safeBatchId = useMemo(() => (batchId ? String(batchId) : ""), [batchId]);

  useEffect(() => {
    let mounted = true;
    const run = async () => {
      setLoading(true);
      setError("");
      setData(null);
      try {
        const res = await getBatchSkus(safeBatchId);
        if (!mounted) return;
        setData(res);
        document.title = `Batch #${res.batchId} • Print`;
      } catch (e) {
        if (!mounted) return;
        const msg =
          e?.response?.data?.message ||
          e?.message ||
          "Failed to load batch items.";
        setError(msg);
      } finally {
        if (!mounted) return;
        setLoading(false);
      }
    };
    run();
    return () => {
      mounted = false;
    };
  }, [safeBatchId]);

  useEffect(() => {
    if (loading || !data) return;
    // Auto-open print dialog after the QR images have a moment to render.
    const t = setTimeout(() => {
      window.print();
    }, 450);
    return () => clearTimeout(t);
  }, [loading, data]);

  if (loading) {
    return (
      <div className="batch-print-page">
        <div className="batch-print-shell">
          <div className="py-4 d-flex align-items-center gap-2">
            <MDBSpinner size="sm" />
            <span className="text-muted">Loading batch...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="batch-print-page">
        <div className="batch-print-shell">
          <p className="text-danger mb-3">{error}</p>
          <button type="button" className="batch-print-retry" onClick={() => window.location.reload()}>
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="batch-print-page">
      <div className="batch-print-shell">
        <div className="batch-print-list">
          {(data?.items || []).map((it) => {
            const sku = it.sku;
            const qrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=210x210&data=${encodeURIComponent(
              sku,
            )}`;
            return (
              <div key={sku} className="batch-print-item">
                <img className="batch-print-qr" src={qrSrc} alt={sku} />
                <p className="batch-print-sku">{sku}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

